import Panel from './panel';
import Container from './container';
import MenuItem from './menuItem';
import SidebarWidget from './sidebarWidget';
import PaginatedTable from './paginatedTable';
import VanillaPaginatedTable from './vanillaPaginatedTable';
import SidebarContainer from './sidebarContainer';
import ContainerLoader from './containerLoader';

//NOTE: This should be phased out of use in favor of in index.js.
//TODO: Remove this file and re-configure entire project to use UI correctly.

var UI = {
	Panel,
	Container,
  ContainerLoader,
	MenuItem,
	SidebarWidget,
	PaginatedTable,
  SidebarContainer,
	VanillaPaginatedTable
}

export default UI



// WEBPACK FOOTER //
// ./src/browser/components/ui/ui.js